import { Box, Button, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { getRoleClaimsSelector } from "../../store/auth/selectors";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SpokeExplorer from "../../components/organisms/spokeExplorer/SpokeExplorer";

const SpokeList = () => {
  const roles = useSelector(getRoleClaimsSelector); // roles  - IDP.Admin or IDP.User

  const [isAdmin, setIsAdmin] = useState(true);

  const navigate = useNavigate();

  const addSpoke = (event: React.MouseEvent<HTMLButtonElement>) => {
    const url = "/AddSpoke"
    if (event.ctrlKey) {
      window.open(url, '_blank')
    }
    else {
      navigate(url);
    }
  };

  useEffect(() => {
    if (roles && roles.length > 0) {
      setIsAdmin(roles.includes("IDP.Admin") ? true : false);
    }
  }, [roles]);

  return (
    <>
      <Box sx={{ paddingBottom: "10px" }}>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={8}>
            <h1 style={{ textAlign: "left" }}>Spokes </h1>
          </Grid>
          <Grid item xs={4} style={{ textAlign: "right" }}>
            {isAdmin && (
              <Button id="05338235-36ef-4572-8488-51c26f97d871"
                color="primary"
                variant="contained"
                onClick={addSpoke}
                endIcon={<AddIcon />}
              >
                Add Spoke
              </Button>
            )}
          </Grid>
        </Grid>
      </Box>
      <SpokeExplorer isAdmin={isAdmin} />
    </>
  );
};

export default SpokeList;
